import {apiAdonis} from '../../../services/api';

export const InvoicesHTTP = {
  get: (params = {}) => apiAdonis.get('/invoices', {params}),
  getById: (id = '') => apiAdonis.get(`/invoices/${id}`),
  create: (payload = {}) => apiAdonis.post('/invoices', payload),
  update: (id = '', params = {}) => apiAdonis.put(`/invoices/${id}`, params),
  delete: (id = '') => apiAdonis.delete(`/invoices/${id}`),
};
